import React, {useEffect} from 'react';
import './App.css';
import SearchBar from "../SearchBar/SearchBar";
import SearchResult from "../SearchResult/SearchResult";
import Playlist from "../Playlist/Playlist";
import Spotify from "../../util/Spotify";

function App() {
    const [playlistTracks, setPlaylistTracks] = React.useState([]);
    const[playlistName, setPlaylistName] = React.useState("");
    const[searchResult, setSearchResult] = React.useState([]);

    useEffect(() => {
        const savedPlaylistTracks = JSON.parse(localStorage.getItem('playlistTracks'));
        const savedPlaylistName = localStorage.getItem('playlistName');
        if (savedPlaylistTracks) setPlaylistTracks(savedPlaylistTracks);
        if (savedPlaylistName) setPlaylistName(savedPlaylistName);
    }, []);

    // Save playlist information to local storage when it changes
    useEffect(() => {
        localStorage.setItem('playlistTracks', JSON.stringify(playlistTracks));
        localStorage.setItem('playlistName', playlistName);
    }, [playlistTracks, playlistName]);

    const searchForTracks = (term) =>{
        Spotify.search(term).then(setSearchResult);
    }

    const handleInputChange = (name) => {
        setPlaylistName(name);
    };


    const removeTrackFromPlaylist = (trackId) => {

        setPlaylistTracks(playlistTracks.filter(track => track.id !== trackId));

    }



    const addTrackToPlaylist = (track) => {
        if(playlistTracks.find(savedTrack => savedTrack.id === track.id)) {
            return;
        }
        setPlaylistTracks([...playlistTracks, track]);

    }

    const saveToSpotify = () => {

        if (!playlistName || playlistName.trim() === "") {
            console.log("Bitte geben Sie einen gültigen Namen für die Playlist ein.");
            return; // Beendet die Funktion, wenn kein gültiger Name vorhanden ist
        }

        if (!playlistTracks.length) {
            console.log("Die Playlist darf nicht leer sein.");
            return; // Beendet die Funktion, wenn keine Tracks vorhanden sind
        }
        const uri = playlistTracks.map(track => track.uri);
        Spotify.savePlaylist(playlistName, uri)
            .then(() =>{
            setPlaylistTracks([]);
            setPlaylistName("");
        })
            .catch(error =>
                console.log("Sie muessen einen Namen eingeben", error));
    }






  return (
      <div className="App">
          <div className="App-header">
            <h1>Ja<span>MM</span>ing</h1>
          </div>
          <div className="search-bar">
          <SearchBar searchForTracks={searchForTracks}/>
          </div>
          <div className="MainPart">
              <SearchResult
                  tracks={searchResult}
                  onAdd={addTrackToPlaylist}

              />
              <Playlist
                  tracks={playlistTracks}
                  onRemove={removeTrackFromPlaylist}
                  handleChange={handleInputChange}
                  playlistName={playlistName}
                  saveToSpotify={saveToSpotify}

              />
          </div>
      </div>
  );
}

export default App;
